export default function searchHeader() {
    if(document.querySelector(".search-button")) {
        let searchOpen = document.querySelector(".search-button");
        let searchInput = document.querySelector(".search-input");
        let searchExit = document.querySelector(".search-input i");
        let searchContent = document.querySelector(".search-content");

        searchOpen.addEventListener("click", () => {
            searchInput.classList.add("is-active");
            searchContent.classList.add("is-active");
        });

        searchExit.addEventListener("click", () => {
            searchInput.classList.remove("is-active");
            searchContent.classList.remove("is-active");
        });
    }
}